import { useMemo } from 'react';
import { SingleSelectFilterPicker } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
export function DateFilterPicker(props) {
  const {
    value,
    onChange: _onChange
  } = props;
  const datesPresets = useMemo(() => [{
    label: 'All time',
    value: 'all-time'
  }, {
    label: 'Today',
    value: 'today'
  }, {
    label: 'This week',
    value: 'this-week'
  }, {
    label: 'This month',
    value: 'this-month'
  }, {
    label: 'Previous month',
    value: 'previous-month'
  }, {
    label: 'Last 3 months',
    value: 'last-three-months'
  }], []);
  return /*#__PURE__*/_jsx(SingleSelectFilterPicker, {
    value: value,
    "data-testid": 'date-filter-picker',
    options: datesPresets,
    label: "Invoice issue date",
    onChange: option => option ? _onChange(option.value) : null
  });
}